module.exports = {
      id: "bell-usage",
      viewBox: "0 0 17 19",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#bell-usage",
      toString: function () {
        return this.url;
      }
    }